import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Company } from '../models/company.model';
import { Config } from '../models/config.model';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private configSubject: BehaviorSubject<Config | null> = new BehaviorSubject<Config | null>(null);
  public config: Observable<Config | null> = this.configSubject.asObservable();

  private _companies = new BehaviorSubject<Company[]>([]);
  public companies: Observable<Company[]> = this._companies.asObservable();


  constructor(private http: HttpClient) {

  }

  loadData() {
    this.http.get<Config>('/api/config')
      .subscribe(
        (data: Config) => {
          if (data != undefined) {
            this.configSubject.next(data);
          }
        },
        (error: HttpErrorResponse) => {
          console.log(error);
        },
        () => {
          console.log('Finished loading config');
        }
      )
  }

  loadCompanies(complaintType: number) {
    this.http.get<Company[]>('/api/form/companies/' + complaintType)
      .subscribe(
        (companies: Company[]) => {
          this._companies.next(companies);
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          //this.airbrake.handleError(error);
        },
        () => {
          console.log('Finished loading companies for type ' + complaintType);
        }
      );
  }


}